// extracted by mini-css-extract-plugin
export default {"cv":"CV_cv__hjtZs","self-info":"CV_self-info__WTXqq"};